import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex); 

// Load store modules dynamically.
const requireContext = require.context("./modules", true, /.*Store\.js$/);

const modules = requireContext
    .keys()
    .map(file => [file.replace(/(^.\/)|(\.js$)/g, ""), requireContext(file)])
    .reduce((modules, [name, module]) => {
        let parts = [];

        if (module.namespaced === undefined) {
            module.namespaced = true;
        }

        parts = name.split("/");
        name = parts[parts.length - 1].substr(0, parts[parts.length - 1].length - 5).toLowerCase();

        return { ...modules, [name]: module };
    }, {});

export default new Vuex.Store({
    modules,
    plugins: []
});
